<template>
  <Layout kind="narrow">
    <div class="section">
      <!-- <div class="content">
        <h1>{{ $t("Browse tags") }}</h1>
        <hr />
        <ul v-for="entry in facets" class="is-unstyled">
          <li>
            <RouterLink :to="{ name: 'Tags', query: { type: entry.value } }">
              {{ entry.value }} ({{ entry.count }} results)
            </RouterLink>
          </li>
          <hr />
        </ul>
      </div> -->
        <div class="title">{{ $t("Browse Tags") }}</div>
        <hr />
        <b-collapse
          class="card"
          animation="slide"
          v-for="(entry, index) of facets"
          :key="index"
          :open="isOpen == index"
          @open="fetchTags(entry)"
        >
          <div
            slot="trigger"
            slot-scope="props"
            class="card-header"
            role="button"
          >
            <p class="card-header-title">
              {{ $t(entry.value) }} ({{ entry.count }} {{$t("results")}})
            </p>
            <a class="card-header-icon">
              <b-icon :icon="props.open ? 'caret-down' : 'caret-up'"> </b-icon>
            </a>
          </div>
          <div class="card-content">
            <a>
              <b-table
                :data="subFacets"
                :per-page="itemsPerPage"
                :paginated="true"
                :columns="columns"
                @click="selected($event,entry)"
              >
              </b-table>
            </a>
          </div>
        </b-collapse>
    </div>
  </Layout>
</template>

<script>
export default {
  data() {
    return {
      facets: [],
      isOpen: null,
      subFacets: [],
      itemsPerPage: 10,
      columns: [
        {
          field: "value",
          label: this.$t('Value'),
          numeric: false,
          searchable: true,
          sortable: true,
        },
        {
          field: "count",
          label: this.$t('Results'),
          numeric: true,
          sortable: true,
        },
      ],
    };
  },
  methods: {
    async fetchTags(entry) {
      const { total, results, facets } = await this.api.fetchTagResults({
        type: entry.value,
        facets: "value",
      });
      this.subFacets = facets.value;
    },
    selected(item,entry) {
      console.log(entry)
      console.log(item)
      let routeData = this.$router.resolve({
        name: "Tags",
        query: { v: item.value , type: entry.value},
      });
      window.open(routeData.href, "_blank");
      // this.$router.push({ name: "Tags", query: { v: item.value, type: entry.value } });
    },
  },

  async mounted() {
    const { total, results, facets } = await this.api.fetchTagResults({
      facets: "type",
    });
    this.facets = facets.type;
  },
};
</script>

<style>
.is-unstyled {
  list-style: none !important;
  margin-left: 0 !important;
}
</style>
